module.exports = __webpack_public_path__ + "static/media/BG_small_Blue.8cbb6c4e.png";